import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { GetTixologiEventsParams } from "@punchup/data/legacy/hooks";
import { getTixologiEvents } from "../utils";
import { useTixologi } from "../useTixologi";

export function useTixologiEvents(
  params: GetTixologiEventsParams,
  options?: { enabled?: boolean }
): UseQueryResult<Awaited<ReturnType<typeof getTixologiEvents>>, Error> {
  const { tixologiData } = useTixologi({
    id: params.venueId,
    isComedian: false,
  });

  return useQuery({
    queryKey: ["tixologiEvents", params, tixologiData?.partnerId],
    queryFn: () =>
      getTixologiEvents({
        ...params,
        partner_id: tixologiData?.partnerId,
        token: tixologiData?.token,
      }),
    enabled: !!tixologiData?.partnerId && (options?.enabled ?? true),
  });
}
